import { FC } from 'react'

import { SearchOption } from '@joor/design-system'

import {
  AgGridFilterComparison,
  AgGridFilterType,
  FilterOptionProps,
} from 'features/Orders/components'

export type SearchFilterProps = FilterOptionProps & {
  onRemoveFilter: (name: string) => void
}

export const SearchFilter: FC<SearchFilterProps> = ({
  name,
  onUpdateFilters,
  onRemoveFilter,
  ...props
}) => {
  const handleChange = ({ searchText }: { searchText: string }): void => {
    if (!searchText) {
      onRemoveFilter(name)
      return
    }

    onUpdateFilters(name, {
      filter: searchText,
      filterType: AgGridFilterType.Text,
      type: AgGridFilterComparison.Contains,
    })
  }

  return <SearchOption {...props} onSearch={handleChange} />
}
